import * as PIXI from 'pixi.js';
import { getGlobalEventEmitter } from '../utils/globalEventEmitter';

export default class ButtonContainer extends PIXI.Container {
    constructor({ bgAssetName, buttonText, buttonTextOffsetY, buttonTextAssetName, textAssetScale, textAssetOffsetY, eventName, disabled }) {
        super();

        if (bgAssetName) {
            const bgTexture = PIXI.Assets.get(bgAssetName);
            const bg = new PIXI.Sprite(bgTexture);
            bg.anchor.set(0.5);
            this.addChild(bg);
        }

        if (buttonTextAssetName) {
            const buttonTextTexture = PIXI.Assets.get(buttonTextAssetName);
            const buttonTextSprite = new PIXI.Sprite(buttonTextTexture);
            buttonTextSprite.x = 0;
            buttonTextSprite.y = textAssetOffsetY || 0;
            buttonTextSprite.scale.set(textAssetScale || 1);
            buttonTextSprite.anchor.set(0.5);
            this.addChild(buttonTextSprite);
        }

        if (buttonText) {
            const text = new PIXI.Text({
                text: buttonText,
                style: {
                    fontFamily: 'Open Sans',
                    fontSize: 34,
                    fill: '#ffffff',
                    fontWeight: 'bold',
                }
            });
            text.label = 'buttonContainerText';
            text.anchor.set(0.5);
            text.x = 0;
            text.y = buttonTextOffsetY || 0;
            this.addChild(text);
        }

        if (eventName) {
            this.eventMode = 'static';
            this.on('pointerdown', (event) => {
                event.stopPropagation();
                getGlobalEventEmitter()?.emit(eventName);
            });
        }

        if (disabled) {
            this.eventMode = 'none';
            this.alpha = 0.5;
        }
    }
}
